module.exports = __webpack_public_path__ + "media/images/pic/testimonials/awatar-02-90fed6bdd126f273e23740ef75128008.svg";